/**
 * Configuration-driven runtime settings. Every backend endpoint the frontend
 * consumes is derived from this single base URL rather than hardcoded per-service.
 */
export interface AppConfig {
  apiBaseUrl: string;
  environment: string;
  /**
   * Backend v2.1's Portfolio/Analytics/Reporting read endpoints all
   * require a `portfolio_id` query parameter (no default) - Falcon is
   * single-portfolio/single-operator in V1 (no portfolio-selection UI
   * exists), so this is the one portfolio identifier every page that
   * consumes those endpoints uses. Configurable via
   * `VITE_DEFAULT_PORTFOLIO_ID` for a deployment that seeds a different
   * portfolio id; falls back to `"default"` otherwise.
   */
  defaultPortfolioId: string;
}

export const appConfig: AppConfig = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "/api/v1",
  environment: (import.meta.env.MODE as string | undefined) ?? "development",
  defaultPortfolioId: (import.meta.env.VITE_DEFAULT_PORTFOLIO_ID as string | undefined) ?? "default",
};
